<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div id="vapp">
        <div class="header">
          <h1 class="title">Regions</h1>
          <div class="buttonsGroup">
            <b-tooltip label="Add a Region" position="is-bottom"
              ><button class="button is-medium is-success" @click="isNewItemActive = true">
                <b-icon icon="plus" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Edit Region" position="is-bottom"
              ><button class="button is-medium is-success" @click="isEditItemActive = true">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip label="Delete a Region" position="is-left"
              ><button class="button is-medium is-danger" @click="DeleteItem()">
                <b-icon icon="trash" size="is-small"></b-icon>
              </button>
            </b-tooltip>
          </div>
        </div>
        <template>
          <b-table
            :data="this.regions"
            :selected.sync="selected"
            :loading="this.isLoading"
            detailed
            hoverable
            detail-key="id"
            :show-detail-icon="true"
            @details-open="(row, index) => this.openDetailRegion(row, index)"
            sticky-header
          >
            <b-table-column field="id" label="Region ID" sortable v-slot="props">
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="name" label="Region Name" sortable v-slot="props">
              {{ props.row.region_name }}
            </b-table-column>
            <b-table-column field="log_url" label="Logs URL" sortable v-slot="props">
              {{ props.row.log_url }}
            </b-table-column>
            <template slot="detail" slot-scope="props">
              <section v-if="rdsDetails[props.row.id] && Object.keys(rdsDetails[props.row.id]).length != 0 && ariSettings[props.row.id] && Object.keys(ariSettings[props.row.id]).length != 0">
                <h1 class="subheading">RDS Settings</h1>
                <b-field label="Host">
                  <b-input v-model="rdsDetails[props.row.id].host"></b-input>
                </b-field>
                <b-field label="Username">
                  <b-input v-model="rdsDetails[props.row.id].username"></b-input>
                </b-field>
                <b-field label="Password">
                  <b-input v-model="rdsDetails[props.row.id].password"></b-input>
                </b-field>
                <div class="buttonsGroup">
                  <b-tooltip label="Save Region Details" position="is-bottom"
                    ><button class="button is-medium is-success" @click="SaveDBDetails(props.row.id)">
                      <b-icon icon="content-save" size="is-small"></b-icon>
                    </button>
                  </b-tooltip>
                  <b-tooltip label="Delete Region Details" position="is-left"
                    ><button class="button is-medium is-danger" @click="DeleteDBDetails(props.row.id)">
                      <b-icon icon="trash" size="is-small"></b-icon>
                    </button>
                  </b-tooltip>
                </div>
              </section>
              <section>
                <h1 class="subheading">ARI Settings</h1>
                <b-field label="Asterisk URL">
                  <b-input v-model="ariSettings[props.row.id].AsteriskARIURL"></b-input>
                </b-field>
                <b-field label="Asterisk Username">
                  <b-input v-model="ariSettings[props.row.id].AsteriskARIUsername"></b-input>
                </b-field>
                <b-field label="Asterisk Password">
                  <b-input v-model="ariSettings[props.row.id].AsteriskARIPassword"></b-input>
                </b-field>
                <b-field label="Key Location">
                  <b-input v-model="ariSettings[props.row.id].GoogleKeyLocation"></b-input>
                </b-field>
                <b-field label="Log Level">
                  <b-input v-model="ariSettings[props.row.id].LogLevel"></b-input>
                </b-field>
              </section>
            </template>
          </b-table>
        </template>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-module @submitted="AddRegion" heading="Add Region" :item="this.formProps"></new-module>
        </b-modal>
        <b-modal :active.sync="isEditItemActive" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal>
          <new-module @submitted="EditRegion" heading="Edit Region" :item="this.selected"></new-module>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
const NewModule = {
  props: {
    item: {
      type: Object,
      required: true,
    },
    heading: {
      type: String,
      required: true,
    },
  },
  template: `
        <form action="" onsubmit="return false">
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{heading}}</p>
                </header>
                <section class="modal-card-body">
                    <b-field label="Region Name">
                        <b-input type="text" v-model="item.region_name"></b-input>
                    </b-field>
                    <b-field label="Logs URL">
                        <b-input type="text" v-model="item.log_url"></b-input>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="$parent.close()">Cancel</button>
                    <button class="button is-primary" @click="$emit('submitted')">{{ heading }}</button>
                </footer>
            </div>
        </form>
        `,
};

export default {
  components: {
    NewModule,
  },
  data: function () {
    return {
      regions: [],
      selected: {},
      isLoading: true,
      isNewItemActive: false,
      isEditItemActive: false,
      formProps: {},
      rdsDetails: {},
      ariSettings: {},
      newApiUrl: "https://api.jeak.co.uk",
    };
  },
  methods: {
    GetItems: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: "Bearer " + token },
      };
      axios
        .get(this.newApiUrl + "/regions", config)
        .then((response) => {
          this.regions = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    DeleteItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to delete first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.$buefy.dialog.confirm({
          title: "Deleting Module",
          message: `Are you sure you want to <b>delete</b> ${this.selected.region_name}? No backsies!`,
          confirmText: "Delete Module",
          type: "is-danger",
          hasIcon: true,
          onConfirm: async () => {
            const token = await this.$cognitoAuth.getIdToken();
            const config = {
              headers: { Authorization: `Bearer ` + token },
            };
            axios
              .delete(this.newApiUrl + `/regions/${this.selected.id}`, config)
              .then((response) => {
                if (response.status == 200) {
                  this.$buefy.toast.open("Module deleted!");
                  this.GetItems();
                } else {
                  this.$buefy.snackbar.open({
                    message: "An error occurred! If this persists, please contact support",
                    type: "is-danger",
                    position: "is-top",
                  });
                }
              })
              .catch((error) => {
                this.$buefy.snackbar.open({
                  message: "An error occurred! If this persists, please contact support",
                  type: "is-danger",
                  position: "is-top",
                });
                console.error(error);
              });
          },
        });
      }
    },
    AddRegion: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        region_name: this.formProps.name,
        log_url: this.formProps.log_url,
      };
      axios
        .post(this.newApiUrl + `/regions`, body, config)
        .then((response) => {
          this.$buefy.toast.open({
            message: "Great Success",
            type: "is-success",
          });
          this.GetItems();
          this.formProps.selected = "";
          this.isNewItemActive = false;
        })
        .catch((error) => {
          this.$buefy.toast.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
          });
          console.error(error);
        });
    },
    openDetailRegion: async function (row, index) {
      if (this.rdsDetails[row.id] && this.ariSettings[row.id]) {
        return;
      }
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      let response = await axios.get(this.newApiUrl + "/regions/" + row.id + "/rdsdetails", config);
      this.rdsDetails[row.id] = response.data;
      response = await axios.get(this.newApiUrl + "/regions/" + row.id + "/arisettings", config);
      this.ariSettings[row.id] = response.data;
      this.isLoading = false;
    },
    DeleteDBDetails: async function (id) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios
        .delete(this.newApiUrl + "/regions/" + id + "/rdsdetails", config)
        .then((response) => {
          this.rdsDetails[id] = null;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
      axios
        .delete(this.newApiUrl + "/regions/" + id + "/arisettings", config)
        .then((response) => {
          this.ariSettings[id] = null;
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    SaveDBDetails: async function (id) {
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };

      axios
        .put(this.apiUrl + "/regions/" + id + "/rdsdetails", this.rdsDetails[id], config)
        .then((response) => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
      axios
        .put(this.apiUrl + "/regions" + id + "/arisettings", this.ariSettings[id], config)
        .then((response) => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    AddDBDetails: async function (id) {
      const body = this.rdsDetails[id];
      if (!(body.host && body.host != "")) {
        this.$buefy.snackbar.open({
          message: "Missing host!",
          type: "is-danger",
          position: "is-top",
        });
        return;
      }
      if (!(body.username && body.username != "")) {
        this.$buefy.snackbar.open({
          message: "Missing username!",
          type: "is-danger",
          position: "is-top",
        });
        return;
      }
      if (!(body.password && body.password != "")) {
        this.$buefy.snackbar.open({
          message: "Missing password!",
          type: "is-danger",
          position: "is-top",
        });
        return;
      }
      console.log(this.rdsDetails[id]);
      this.isLoading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios
        .post(this.apiUrl + "/regions/" + id + "/rdsdetails", this.rdsDetails[id], config)
        .then((response) => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          console.error(error);
        });
    },
    EditRegion: async function (id) {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      const body = {
        id: this.selected.id,
        name: this.selected.name,
        log_url: this.selected.log_url,
      };
      let regionId = id;
      if (!id) regionId = this.selected.id;
      axios
        .put(this.apiUrl + "/regions/" + regionId, body, config)
        .then((response) => {
          this.isEditItemActive = false;
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
          this.isEditItemActive = false;
          console.error(error);
        });
    },
  },
  mounted() {
    this.GetItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.subheading {
  text-align: center;
  font-size: 1.3em;
  font-weight: bold;
}
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.header h1 {
  grid-column: 1/6;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.b-table {
  height: 100%;
  max-height: 650px;
}
</style>
